const KEYS = {
  theme: "theme",
  propertiesViewMode: "properties-view-mode"
}

const DEFAULTS = {
  theme: "light",
  propertiesViewMode: "list"
}

export default {
  get theme() {
    const stored = localStorage.getItem(KEYS.theme)
    if (stored) return stored

    // Follow system preference if no explicit choice
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  },

  set theme(value) {
    localStorage.setItem(KEYS.theme, value)
  },

  get propertiesViewMode() {
    return localStorage.getItem(KEYS.propertiesViewMode) || DEFAULTS.propertiesViewMode
  },

  set propertiesViewMode(value) {
    localStorage.setItem(KEYS.propertiesViewMode, value)
  }
}
